import apiClient from '@/plugins/axios'

export default {
  getAcionados(filter) {
    return apiClient.post('acionadosProcesso/index', filter)
  },

  getAcionado(id) {
    return apiClient.get(`acionadosProcesso/${id}`)
  },

  getCpfCnpj(cpfcnpj) {
    return apiClient.get(`acionadosProcesso/getcpfcnpj/${cpfcnpj}`)
  },

  postAcionado(acionado) {
    return apiClient.post(`acionadosProcesso`, { acionado })

  },

  putAcionado(id, acionado) {
    return apiClient.put(`acionadosProcesso/${id}`, { acionado })

  },

  deleteAcionado(id) {
    return apiClient.delete(`acionadosProcesso/${id}`)

  },

  getPagination(url) {
    return apiClient.post(url)
  }

}


// WEBPACK FOOTER //
// ./src/views/Acionado/_services/AcionadoService.js